import styled from 'styled-components';

export const Avatar = styled.div<{ bg: string; $large: boolean }>`
    width: ${({ $large }) => ($large ? 48 : 34)}px;
    height: ${({ $large }) => ($large ? 48 : 34)}px;
    border-radius: ${({ $large }) => ($large ? 10 : 8)}px;
    flex-shrink: 0;
    background: ${({ bg }) => bg};
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${({ $large }) => ($large ? 14 : 12)}px;
    font-weight: 700;
    overflow: hidden;
`;

export const AvatarImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
